import { render, staticRenderFns } from "./AfternoonTea.vue?vue&type=template&id=2264205e&scoped=true"
import script from "./AfternoonTea.vue?vue&type=script&lang=js"
export * from "./AfternoonTea.vue?vue&type=script&lang=js"
import style0 from "./AfternoonTea.vue?vue&type=style&index=0&id=2264205e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264205e",
  null
  
)

export default component.exports